import { AfterViewInit, Component, Signal, WritableSignal, computed, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { Tooltip } from 'primeng/tooltip';
import { CoreModule } from '@core/core.module';

import guides from '@environments/guides';

import { BreadcrumbService } from '../../service/breadcrumb.service';
type Help = {
  id: string;
  description?: string;
};
@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  imports: [CoreModule, ButtonModule, ToolbarModule, Tooltip],
})
export class BreadcrumbComponent implements AfterViewInit {
  protected items: Signal<MenuItem[]>;
  protected support: WritableSignal<Help | undefined> = signal<Help | undefined>(undefined);
  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router
  ) {
    this.items = computed(() => this.breadcrumbService.getItems());
  }

  ngAfterViewInit(): void {
    const guideId = this.activatedRoute.snapshot.firstChild?.data['guideId'];
    const guide = guides.find(guide => guide.id === guideId);

    if (guideId && guide) {
      this.support.set({ id: guideId, description: guide.description });
    }

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const guideId = this.activatedRoute.snapshot.firstChild?.data['guideId'];

      if (guideId === this.support()?.id) {
        return;
      }

      const guide = guides.find(guide => guide.id === guideId);

      if (guide) {
        this.support.set({ id: guideId, description: guide.description });
      } else {
        this.support.set(undefined);
      }
    });
  }
}
